import React, { Component } from "react";

import i18n from "i18n-react";
import { BackImage } from "C4";
import { HashLink as Link } from "react-router-hash-link";

import { baseAppId } from "settings";

export default class RewardsView extends Component {
  render() {
    return (
      <div className="contentContainer BookingForm">
        <BackImage />
        <div className="header">
          <Link to="/main">
            <img
              src={`https://s3.amazonaws.com/developertool/${baseAppId}/logo.png`}
              alt="Logo"
              className="logo"
            />
          </Link>
          <h3>{i18n.translate("rewards.bookingForm.title")}</h3>
        </div>
        <hr />
        <div className="bodyRewardsTerms">
          <h1>TERMS & CONDITIONS</h1>
          <p>...</p>
          <hr />
          <div className="buttonHolder">
            <Link to="/main/rewards">
              <button type="button" className="btn">
                Return to landing &gt;
              </button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
